export default __webpack_public_path__ + "static/hero-3-36c4439c68bb280b947601c9f0fb4f44.webp";